import '../main.less';
import React from 'react';
import { Field, reduxForm } from 'redux-form';

import Checkbox from '../../../../shared/form-elements/checkbox';

const Form = props => {

	return (
		<div className="payout-request-form-wrap payouts-form-in-modal">
			<form
				className="ui-form payouts-form__main clearfix display-flex-column"
			>
				<div className="payout-request-form__main-fields">
					<div className="ui-form__element margin-10">
						<Field
							name="is_request_only"
							placeholder={props.intl('Is requests only')}
							component={Checkbox}
						/>
					</div>
				</div>
			</form>
		</div>
	);
};

export default reduxForm({ form: 'payoutRequestsStatParams' })(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/forms/requests-stat-params/main.js